import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import './styles.css';
import MHGraphic from './img/Dual-Continuum-Model-Mental-Health-Illness@3x.png';

class MentalModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalShowing: false,
      modalId: null
    };

    this.onHideModal = this.onHideModal.bind(this);
    this.onShowModal = this.onShowModal.bind(this);
  }

  onHideModal() {
    this.setState({
      modalShowing: false
    });
  }

  onShowModal(modalId) {
    this.setState({
      modalShowing: true,
      modalId
    });
  }

  renderModal() {
    if (this.state.modalShowing) {
      const modalId = this.state.modalId;
      let modalTitle = '(No Title)';
      let modalContent = '';

      if (modalId === 1) {
        modalTitle = 'Dual Continuum Model of Mental Health and Mental Illness';
        modalContent =
          'The dual continuum model was defined by Corey Keyes, a sociologist and psychologist at Emory University. According to Keyes, languishing implies the presence of some level of mental health impairment that interferes with social and/or occupational functioning, but does not necessarily imply the presence of a mental illness. Languishing can be as limiting to an individual as a diagnosable mental illness. Conversely, individuals with a diagnosed mental illness can flourish, experiencing positive mental wellness (Canadian Association of College & University Student Services and Canadian Mental Health Association, 2013).';
      }

      return (
        <Modal
          className="mh-modal"
          show={this.state.modalShowing}
          onHide={this.onHideModal}
        >
          <Modal.Header closeButton />
          <Modal.Body>
            <h1 className="txt-ltblue text-center">{modalTitle}</h1>
            <p>{modalContent}</p>
          </Modal.Body>
        </Modal>
      );
    }

    return null;
  }

  render() {
    return (
      <div className="mh-continuum">
        <Button
          className="open-info"
          aria-label="More Information"
          role="button"
          onClick={() => {
            this.onShowModal(1);
          }}
        >
          Click for more information
        </Button>
        <img
          className="img-block img-responsive mh-image"
          src={MHGraphic}
          width="588"
          alt="
              Graphic of the Dual Continuum Model of Mental Health and Mental Illness.
              Starting clockwise from optimum mental health (flourishing) on blue arrow, optimum mental health without mental illness, no mental illness symptoms beside green arrow (right axis),
               poor mental health without mental illness, poor mental health (Languishing) under orange arrow, poor mental health with mental illness, and serious mental illness beside red arrow (left axis).
              "
        />
        <div
          id="modal"
          aria-hidden="false"
          aria-label="Dialog  Window  -  Close  (Press  escape  to  close)"
          role="dialog"
          tabIndex="0"
        >
          {this.renderModal()}
        </div>
      </div>
    );
  }
}

const MHModal = MentalModal;

export default MHModal;



// WEBPACK FOOTER //
// ./src/components/MentalModal/index.jsx